/**
 * Pure half of the per-widget settings sheet (P3-18): period options + schema-driven sanitizing.
 */
export const PERIOD_OPTIONS = Object.freeze([
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '12m', label: 'Last 12 months' },
  { value: 'all', label: 'All history' },
]);

/** Keep only schema keys; fall back to defaults; coerce types. Pure — exported for tests. */
export function sanitizeSettings(schema, values, { scopeOptions = [] } = {}) {
  const out = {};
  for (const field of schema || []) {
    const raw = values?.[field.key];
    switch (field.type) {
      case 'toggle':
        out[field.key] = raw == null ? Boolean(field.default) : Boolean(raw);
        break;
      case 'select': {
        const ok = field.options.some((o) => (o.value ?? o) === raw);
        out[field.key] = ok ? raw : field.default ?? (field.options[0]?.value ?? field.options[0]);
        break;
      }
      case 'period':
        out[field.key] = PERIOD_OPTIONS.some((o) => o.value === raw) ? raw : field.default || '90d';
        break;
      case 'scope':
        out[field.key] = raw && scopeOptions.some((o) => o.value === raw) ? raw : '';
        break;
      case 'text':
        out[field.key] = raw == null ? field.default ?? '' : String(raw).slice(0, 200);
        break;
      default:
        break;
    }
  }
  return out;
}

